import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Config} from '../../utilities/config';
import {hasOwnProperty} from 'tslint/lib/utils';
import {isObjectEmpty} from 'src/app/Shared/utilities/helpers';
import {RestfulHttpService} from '../../../services/httpService/service.service';
declare const $: any;

@Injectable({
  providedIn: 'root',
})
export class ApiReqHandlersService extends Config {
  constructor(private http: HttpClient, private restServ: RestfulHttpService) {
    super();
  }

  /**
   * post
   * @param path
   * @param data
   * @returns Observable
   */
  public post(path: string, data?: any): Observable<any> {
    this.headers = { headers: this.setHeaders() };

    // const url = `${ApiReqHandlersService.BASE_URL}${path}`;
    const endpoint = this.restServ.reRouteBaseUrl(null, path);
    return this.http.post(endpoint, data || {}, this.headers);
  }


  public get(path: string, params?: any): Observable<any> {
    this.headers = { headers: this.setHeaders(), params};
    // const url = `${ApiReqHandlersService.BASE_URL}${path}`;
    const endpoint = this.restServ.reRouteBaseUrl(null, path);
    return this.http.get(endpoint, this.headers);
  }

  /**
   *
   * @param {string} path
   * @param data
   * @returns {Observable<any>}
   */
  public put(path: string, data?: any): Observable<any> {
    this.headers = { headers: this.setHeaders() };
    // const url = `${ApiReqHandlersService.BASE_URL}${path}`;
    const endpoint = this.restServ.reRouteBaseUrl(null, path);
    return this.http.put(endpoint, data, this.headers);
  }

  /**
   *
   * @param {string} path
   * @param data
   * @returns {Observable<any>}
   */
  public patch(path: string, data?: any): Observable<any> {
    this.headers = { headers: this.setHeaders() };
    // const url = `${ApiReqHandlersService.BASE_URL}${path}`;
    const endpoint = this.restServ.reRouteBaseUrl(null, path);
    return this.http.patch(endpoint, data, this.headers);
  }

  /**
   *
   * @param path
   * @param data
   */
  public delete(path: string, data?: any): Observable<any> {
    this.headers = { headers: this.setHeaders() };
    // const url = `${ApiReqHandlersService.BASE_URL}${path}`;
    const endpoint = this.restServ.reRouteBaseUrl(null, path);
    return this.http.delete(endpoint, this.headers);
  }

  /**
   * @param urlLink
   * @param formFile
   * @param file_key
   * @param data
   * @param method
   */
  public postFile(
    urlLink: string,
    formFile,
    file_key = 'file',
    data?,
    method?
  ): Observable<any> {
    const header = this.setHeaders();
    header.delete('Content-Type');
    this.headers = { headers: header };
    const urlPath = urlLink;
    const formData = new FormData();
    let file = null;
    console.log(formFile);
    if (formFile && formFile.files[0]) {
      file = formFile.files[0];
      // console.log('Here is the form file ::', file);
      formData.append(file_key, file, file.name);
    }
    if (data && !isObjectEmpty(data)) {
      console.log(data);
      Object.keys(data).forEach((key, index) => {
        formData.append(key, data[key]);
      });
    }
    console.log(formData);
    // formData.append("body", data);
    // const url = `${ApiReqHandlersService.BASE_URL}${urlPath}`;
    const endpoint = this.restServ.reRouteBaseUrl(null, urlPath);
    return this.http.post(endpoint, formData || {}, this.headers);
  }

  /**
   *
   * @param data
   * @param formFiles
   * @param urlLink
   * @param file_key
   */
  public postMultipleFile(
    urlLink: string,
    formFiles,
    file_key = 'file',
    data: any,
  ): Observable<any> {
    const header = this.setHeaders();
    // header.delete('Content-Type');
    header.append('Content-Type', 'multipart/form-data');
    this.headers = { headers: header };
    // const path = $.param(data);
    const urlPath =  urlLink;
    const formData = new FormData();
    const docs = [];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < formFiles.length; i++) {
      if (formFiles[i] && formFiles[i].files[0]) {
        // formData.append(file_key, formFiles[i].files[0], formFiles[i].files[0].name);
        formData.append(`${file_key}[${i}]`, formFiles[i].files[0], formFiles[i].files[0].name);
      }

      if (data[i] && !isObjectEmpty(data[i])) {
        Object.keys(data[i]).forEach((key, index) => {
          // formData.append(`documents[${i}].${key}`, data[i][key]);
          formData.append(`${key}[${i}]`, data[i][key]);
        });
      }
      formData.delete(`files[${i}]`);
      formData.delete(`personnel_id[${i}]`);
    }
    formData.append('personnel_id', data[0].personnel_id);
    console.log(formData);
    // return;
    // const url = `${ApiReqHandlersService.BASE_URL}${urlPath}`;
    const endpoint = this.restServ.reRouteBaseUrl(null, urlPath);
    return this.http.post(endpoint,  formData || {}, this.headers);
  }
}
